import { Routes } from '@angular/router';

import { siteGuard } from '@core/guards/site.guard';
import { titleFormatter } from '@core/utils/general.utils';
import { codeResolver } from '@core/resolvers/code.resolver';

import { organizationRoutes } from '@features/organizations/organizations.routes';
import { memberRoutes } from '@features/members/members.routes';
import { matchesRoutes } from '@features/matches/matches.routes';
import { HomeComponent } from '@features/organizations/pages/Home/Home.component';
import { importRoutes } from '@features/import/import.routes';
import { liveRoutes } from '@features/live/live.routes';
import { seasonRoutes } from '@features/seasons/seasons.routes';
import { snapshotRoutes } from '@features/snapshots/snapshots.routes';

import { MainTemplateComponent } from '@templates/main-template/main-template.component';
import { HalfpageTemplateComponent } from '@templates/halfpage-template/halfpage-template.component';
import { PublicTemplateComponent } from '@templates/public-template/public-template.component';

import { LoginComponent } from '@pages/Login/Login.component';
// import { SignUpComponent } from '@pages/SignUp/SignUp.component';
import { LoadingComponent } from '@pages/Loading/Loading.component';
import { ForgotComponent } from '@pages/Forgot/Forgot.component';
import { NotFoundComponent } from '@pages/NotFound/NotFound.component';
import { InviteComponent } from '@pages/Invite/Invite.component';

export const routes: Routes = [
  { path: 'not-found', component: NotFoundComponent },
  {
    path: 'loading',
    title: titleFormatter('Loading'),
    component: LoadingComponent,
  },
  {
    path: '',
    component: MainTemplateComponent,
    canActivate: [siteGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        title: titleFormatter('Organizations'),
        pathMatch: 'full',
      },
      ...organizationRoutes,
      ...memberRoutes,
      ...matchesRoutes,
      ...importRoutes,
      ...seasonRoutes,
      ...snapshotRoutes,
    ],
  },
  {
    path: '',
    component: HalfpageTemplateComponent,
    children: [
      {
        path: 'login',
        title: titleFormatter('Login'),
        data: {
          backgroundImage:
            'https://images.unsplash.com/photo-1735835590796-7032476e7d48?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=667&q=80',
        },
        component: LoginComponent,
      },
      // {
      //   path: 'signup',
      //   title: titleFormatter('Sign up'),
      //   data: {
      //     backgroundImage:
      //       'https://images.unsplash.com/photo-1736941299356-a863f0d9081d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=667&q=80',
      //   },
      //   component: SignUpComponent,
      // },
      {
        path: 'forgot',
        title: titleFormatter('Forgot password'),
        data: {
          backgroundImage:
            'https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=667&q=80',
        },
        component: ForgotComponent,
      },
{
        path: 'invite/:code',
        title: titleFormatter('Invite Code'),
        canActivate: [siteGuard],
        resolve: { invite: codeResolver },
        data: {
          backgroundImage:
            'https://images.unsplash.com/photo-1610562966490-fbee642e7821?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=667&q=80',
        },
        component: InviteComponent,
      },
    ],
  },
  {
    path: '',
    component: PublicTemplateComponent,
    children: [...liveRoutes],
  },
  { path: '**', redirectTo: '/not-found' },
];
